<template>
  <transition name="modal" v-if="editRewardItem">
    <div class="modal-mask">
      <div class="modal-wrapper" @click.self="cancel">
        <div class="modal-container">
          <div class="modal-header">
            <h3>Edit Reward Item</h3>
          </div>
          <div class="modal-body form-horizontal">
            <!-- FIELD NAME -->
            <div class="form-group">
              <label for="fieldName" class="control-label col-sm-3">Name</label>
              <div class="col-sm-9 input-group">
                <input
                  id="fieldName"
                  class="form-control admin-form-control"
                  type="text" name="name"
                  v-model="currentRewardItem.name"
                  placeholder="Name">
              </div>
            </div>
            <div class="clearfix"></div>
            <div class="form-group">
              <label for="fieldDescription" class="control-label col-sm-3">Description</label>
              <div class="col-sm-9 input-group">
                <editor
                  name="appendedOutput"
                  :api-key="editorKey"
                  :init="tinyOptions"
                  v-model="currentRewardItem.description"
                ></editor>
              </div>
            </div>
            <div class="clearfix"></div>
            <div class="form-group">
              <label for="archive" class="control-label col-sm-3">Archive</label>
              <div class="col-sm-9 input-group checkbox-center">
                <input
                  id="archive"
                  v-model="currentRewardItem.archived"
                  type="checkbox"
                  name="">
              </div>
            </div>
            <div class="clearfix"></div>
            <div class="form-group">
              <label for="fieldPoints" class="control-label col-sm-3">Points</label>
              <div class="col-sm-9 input-group">
                <input
                  id="fieldPoints"
                  class="form-control admin-form-control"
                  type="number" name="points"
                  v-model="currentRewardItem.points"
                  placeholder="Points">
              </div>
            </div>
            <div class="clearfix"></div>
            <div class="form-group">
              <label for="fieldSizes" class="control-label col-sm-3">Sizes</label>
              <div class="col-sm-9 input-group">
                <select multiple id="fieldSizes" v-model="currentRewardItem.sizes" class="form-control admin-form-control">
                  <option v-for="(size, index) in itemSizes" :key="index" :value="size">{{ size }}</option>
                </select>
              </div>
            </div>
            <div class="clearfix"></div>
            <div class="form-group">
              <label for="fieldCustomSizes" class="control-label col-sm-3">Custom Sizes</label>
              <div class="col-sm-9 input-group">
                <button class="btn btn-sm clickable link-hover" @click="addSize">Add Size</button>
                <div
                  v-for="(size, index) in currentRewardItem.customSizes"
                  class="custom-field-group"
                  :key="index"
                  >
                  <input
                    type="text"
                    v-model="currentRewardItem.customSizes[index]"
                    class="col-md-11"
                    placeholder="Size">
                  <div class="col-md-1">
                    <span class="glyphicon glyphicon-trash" @click="removeSize(index)"></span>
                  </div>
                </div>
              </div>
            </div>
            <div class="clearfix"></div>
            <div class="form-group">
              <label for="fieldColors" class="control-label col-sm-3">Colors</label>
              <div class="col-sm-9 input-group">
                <select multiple id="fieldColors" v-model="currentRewardItem.colors" class="form-control admin-form-control">
                  <option v-for="(color, index) in itemColors" :key="index" :value="JSON.stringify(color)">{{ toReadable(color.name) }}</option>
                </select>
              </div>
            </div>
            <div class="form-group">
              <label for="fieldCustomColors" class="control-label col-sm-3">Custom Colors</label>
              <div class="col-sm-9 input-group">
                <button class="btn btn-sm clickable link-hover" @click="addColor">Add Color</button>
                <div
                  v-for="(color, index) in currentRewardItem.customColors"
                  class="custom-field-group"
                  :key="index"
                  >
                  <input
                    type="text"
                    v-model="color.name"
                    class="col-md-5"
                    placeholder="Color Name">
                  <input
                    type="text"
                    v-model="color.hex"
                    class="col-md-5 col-md-offset-1"
                    placeholder="Color Code (e.g. D64D4D)">
                  <div class="col-md-1">
                    <span class="glyphicon glyphicon-trash" @click="removeColor(index)"></span>
                  </div>
                </div>
              </div>
            </div>
            <div class="clearfix"></div>
            <form-image-uploader
              v-model="currentRewardItem.image"
              :albumName="'rewardItems'"
              :inputLabel="'Image'"
              ></form-image-uploader>
          </div>
          <div class="modal-footer">
            <button class="btn btn-default" @click="cancel">Cancel</button>
            <button class="btn admin-btn-primary" @click="save">Save</button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'
import FormImageUploader from '../../FormImageUploader'
import S3 from '../../../_helpers/awsS3.js'
import Editor from '@tinymce/tinymce-vue'
const _ = require('lodash')

export default {
  name: 'RewardItemModal',
  props: ['editRewardItem', 'currentRewardItemIndex', 'program', 'isNew'],
  components: {
    'form-image-uploader': FormImageUploader,
    editor: Editor
  },
  watch: {
    editRewardItem: function (val) {
      if (val) {
        this.rewardItemOriginalData = JSON.parse(JSON.stringify(this.currentRewardItem))
      } else {
        this.rewardItemOriginalData = {}
      }
    }
  },
  data () {
    return {
      editorKey: '7bb76f8qmjwrxz0hn4kh6gyt3bs2fyk3pv7xavth6kcn3460',
      tinyOptions: {
        body_class: 'form-control admin-form-control input-lg',
        height: 200,
        menubar: false,
        toolbar: 'undo redo | styleselect | bold italic | alignleft aligncenter alignright justify | numlist bullist outdent indent | forecolor | removeformat',
        plugins: ['lists']
      },
      rewardItemOriginalData: {},
      itemSizes: [
        'X-Small',
        'Small',
        'Medium',
        'Large',
        'X-Large'
      ],
      itemColors: [
        { name: 'Red', hex: 'f44336' },
        { name: 'Orange', hex: 'f39500' },
        { name: 'Yellow', hex: 'ffeb3b' },
        { name: 'Green', hex: '4caf50' },
        { name: 'Blue', hex: '2949fd' },
        { name: 'Purple', hex: '673ab7' },
        { name: 'Black', hex: '000' },
        { name: 'White', hex: 'fff' }
      ]
    }
  },
  computed: {
    currentRewardItem: {
      get () {
        return this.program.rewardItems[this.currentRewardItemIndex]
      },
      set (value) {
        this.program.rewardItems[this.currentRewardItemIndex] = value
      }
    }
  },
  methods: {
    ...mapMutations('loyaltyProgram', {
      setProgram: 'SET_PROGRAM',
      updateProgram: 'UPDATE_PROGRAM'
    }),
    ...mapActions('loyaltyProgram', [ 'saveProgram' ]),
    toReadable (word) {
      let copy = word.toString()
      let words = copy.match(/[A-Za-z][a-z]*/g) || []
      return words.map(word => {
        return word.charAt(0).toUpperCase() + word.substring(1)
      }).join(' ')
    },
    addColor () {
      this.currentRewardItem.customColors.push({ name: '', hex: '' })
    },
    removeColor (index) {
      let copy = _.cloneDeep(this.currentRewardItem.customColors)
      copy.splice(index, 1)
      this.currentRewardItem.customColors = copy
    },
    addSize () {
      this.currentRewardItem.customSizes.push('')
    },
    removeSize (index) {
      let copy = _.cloneDeep(this.currentRewardItem.customSizes)
      copy.splice(index, 1)
      this.currentRewardItem.customSizes = copy
    },
    async cancel () {
      if (this.isNew) {
        if (this.currentRewardItem.image.imageKey) {
          await S3.removeFromS3(this.currentRewardItem.image.imageKey)
        }
        const copyWithoutLast = this.program.rewardItems.slice(0, -1)
        this.updateProgram({ prop: 'rewardItems', value: copyWithoutLast })
      } else {
        this.currentRewardItem = this.rewardItemOriginalData
      }
      this.$emit('close')
    },
    save () {
      if (this.currentRewardItem.image.url === null && this.currentRewardItem.fileName !== null) {
        this.currentRewardItem.image = this.rewardItemOriginalData.image
      }
      this.setProgram(this.program)
      this.saveProgram()
        .then(response => {
          this.$emit('close')
        })
        .catch(err => {
          console.log(err)
        })
    }
  }
}
</script>

<style scoped>
.modal-body {
  max-height: 60vh;
  overflow-y: auto;
}

.modal-enter-active, .modal-leave-active {
  transition: opacity .6s;
}
.modal-enter, .modal-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.custom-field-group {
  display: flex;
  align-items: center;
  padding: 5px;
  border: 1px solid #eae9e9;
  border-radius: 5px;
}

.custom-field-group:not(:last-child) {
  margin-bottom: 5px;
}

.custom-field-group input {
  border: none;
  border-bottom: 1px solid #efefef;
}

.link-hover:hover {
  font-weight: bold;
  text-decoration: underline;
}
</style>
